export default {
  setSearchedTweetEntities(state, payload) {
    state.searchedTweetEntities = payload;
  },
  setSearchFeedAccounts(state, payload) {
    state.searchFeedAccounts = payload;
  },

  setSearchFeed(state, payload) {
    state.searchFeed = payload;
  },
};
